import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * External dependencies
 */
import classnames from 'classnames';
/**
 * WordPress dependencies
 */

import { createElement } from '@wordpress/element';
export var Circle = function Circle(props) {
  return createElement('circle', props);
};
export var G = function G(props) {
  return createElement('g', props);
};
export var Path = function Path(props) {
  return createElement('path', props);
};
export var Polygon = function Polygon(props) {
  return createElement('polygon', props);
};
export var Rect = function Rect(props) {
  return createElement('rect', props);
};
export var Defs = function Defs(props) {
  return createElement('defs', props);
};
export var RadialGradient = function RadialGradient(props) {
  return createElement('radialGradient', props);
};
export var LinearGradient = function LinearGradient(props) {
  return createElement('linearGradient', props);
};
export var Stop = function Stop(props) {
  return createElement('stop', props);
};
export var SVG = function SVG(_ref) {
  var className = _ref.className,
      isPressed = _ref.isPressed,
      props = _objectWithoutProperties(_ref, ["className", "isPressed"]);

  var appliedProps = _objectSpread({}, props, {
    className: classnames(className, {
      'is-pressed': isPressed
    }) || undefined,
    role: 'img',
    'aria-hidden': 'true',
    focusable: 'false'
  }); // Disable reason: We need to have a way to render HTML tag for web.
  // eslint-disable-next-line react/forbid-elements


  return createElement("svg", appliedProps);
};
//# sourceMappingURL=index.js.map